import React, { useState, useCallback, useMemo } from 'react'

import classnames from 'classnames'
import Image from 'next/image'
import { DownOutlined } from '@ant-design/icons';
import { Input, Dropdown, Select, Button, Form, message } from 'antd'

import ModeSelect from '@/components/form/ModeSelect'
import useUserReducers from '@/store/user'
import { usePcLoginConfirm } from '@/utils/modal/useLoginConfirm'
import sendIcon from './assets/send.png'
import styles from './ArticlePrompt.module.scss'

export default function ArticlePrompt({
  contentProps = { name: 'content', maxLength: 1000, placeholder: '请输入' },
  corpusChange,
  hideContent = false,
  corpusOptions,
  onSubmit,
  extra,
  className,
  autoSize = { minRows: 3, maxRows: 10 },
  form,
  tip = ''
}) {
  const [loading, setLoading] = useState(false)
  const [userState] = useUserReducers()
  const showLoginConfirm = usePcLoginConfirm()

  const submit = useCallback(async (e) => {
    const values = await form.validateFields()
    if (!hideContent && values[contentProps.name].replace(/\s/g, '').length === 0) {
      return message.info('请输入内容')
    }
    setLoading(true)
    onSubmit(values).then(() => {
      form.setFieldValue('content', '')
      setLoading(false)
    }).catch((err) => {
      setLoading(false)
    })
  }, [onSubmit, contentProps, hideContent])

  const languageOptions = useMemo(() => {
    return [{ value: '默认', label: '语言'}, '中文','英语','英式英语','美试英语','法语','俄语','日语','韩文','泰文','德语'].map(item => {
      if (typeof item === 'string') {
        return { value: item, label: item}
      }
      return item
    })
  }, [])

  const toneOptions = useMemo(() => {
    return [{ value: '默认', label: '语气'},'权威的','临床的','官方的','自信的','感同身受的','友善的','幽默的','非正式的','乐观的','悲观的','俏皮的','讽刺的','严肃的'].map(item => {
      if (typeof item === 'string') {
        return { value: item, label: item}
      }
      return item
    })
  }, [])

  const typeOptions = useMemo(() => {
    return [{ value: '默认', label: '风格'},'学术论文','分析报告','辩论稿','对话','发明书','书信','说明文','新闻','叙事','诗歌','小说','散文','技术报告']
      .map(item => {
        if (typeof item === 'string') {
          return { value: item, label: item}
        }
        return item
      })
  }, [])

  return (
    <Form className={classnames(styles.container, className)} form={form} initialValues={{ language: '默认', tone: '默认', article_type: '默认', 'model': 'gpt-3.5'}}>
      {
        !userState.userInfo &&
        <div className={styles.login} onClick={showLoginConfirm}/>
      }
      {
        tip &&
        <div className={styles.tip}>
          { tip }
        </div>
      }
      <div className={styles.toolbar}>
        {
          corpusOptions &&
          <Dropdown menu={{ items: corpusOptions, onClick: corpusChange }}>
            <Button className={styles.dropdown} type="link">提示语料库 &gt;</Button>
          </Dropdown>
        }
        {
          extra && <div className={styles.extra}>{extra}</div>
        }
        {
          !extra &&
          <div className={styles.extra}>
            个性化：
            <Form.Item name="model">
              <ModeSelect></ModeSelect>
            </Form.Item>
            <Form.Item name="language">
              <Select options={languageOptions} size="middle" dropdownMatchSelectWidth={false}/>
            </Form.Item>
            <Form.Item name="tone">
              <Select options={toneOptions} size="middle" dropdownMatchSelectWidth={false}/>
            </Form.Item>
            <Form.Item name="article_type">
              <Select options={typeOptions} size="middle" dropdownMatchSelectWidth={false}/>
            </Form.Item>
          </div>
        }
      </div>
      {
        !hideContent &&
        <div className={classnames(styles.content, contentProps.className)}>
          <Button className={styles.submit} type="primary" loading={loading} size="middle" onClick={submit}>
            <Image alt="" height={30} src={sendIcon}/>
          </Button>
          <Form.Item name={contentProps.name} rules={[{ required: true, message: '请输入内容' }]}>
            <Input.TextArea maxLength={contentProps.maxLength} showCount placeholder={contentProps.placeholder} autoSize={autoSize}/>
          </Form.Item>
        </div>
      }
    </Form>
  )
}
